export default function getLessonUrl(topicId: number, lessonId: number) {
  return `/learning/lessons/${topicId}/${lessonId}`;
}
